import styled from "styled-components";
import { Card, CardBody } from "shards-react";

export const CustomizedCard = styled(Card)``;

export const CustomizedCardBody = styled(CardBody)`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
`;
